import { render, staticRenderFns } from "./uploadWb.vue?vue&type=template&id=3f052a72&scoped=true"
import script from "./uploadWb.vue?vue&type=script&lang=js"
export * from "./uploadWb.vue?vue&type=script&lang=js"
import style0 from "./uploadWb.vue?vue&type=style&index=0&id=3f052a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f052a72",
  null
  
)

export default component.exports